import { useNavigate } from "react-router-dom";
import { message } from "antd";
import { useRecoilState } from "recoil";
import { UserInfo } from "@/models/user";

// 自定义操作
export const useCustomOperate = () => {
  // 路由
  const navigator = useNavigate();
  // 用户信息
  const [, setUserInfo] = useRecoilState(UserInfo);

  // 处理打开
  const customOpen = (path: string) => {
    navigator(path);
  };

  // 处理重定向
  const customReplace = (path: string) => {
    navigator(path, { replace: true });
  };

  // 处理登录
  const customLogin = (token: string) => {
    localStorage.token = token;
    customReplace('/');
    message.success('登录成功');
  };

  // 处理退出
  const customLogout = () => {
    delete localStorage.token;
    customReplace('/login');
    message.success('退出成功');
    setUserInfo(null);
  };

  return { customOpen, customReplace, customLogin, customLogout };
};